var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_695_1122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_695_1122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "light_2",
    d: "M15 25.048C13.8082 25.048 12.7985 24.6342 11.9708 23.8064C11.1431 22.9787 10.7292 21.969 10.7292 20.7772H5.9455C5.52404 20.7772 5.15694 20.6209 4.84419 20.3081C4.53142 19.9954 4.37503 19.6282 4.37503 19.2068C4.37503 16.3238 5.31307 13.8425 7.18916 11.7629C9.06522 9.6833 11.4071 8.54976 14.2148 8.36226V5.40073C14.2148 5.17477 14.2892 4.98741 14.4381 4.83864C14.5869 4.68987 14.7744 4.61548 15.0006 4.61548C15.2267 4.61548 15.414 4.68987 15.5625 4.83864C15.711 4.98741 15.7852 5.17477 15.7852 5.40073V8.36226C18.5929 8.54976 20.9348 9.6833 22.8108 11.7629C24.6869 13.8425 25.625 16.3238 25.625 19.2068C25.625 19.6282 25.4686 19.9954 25.1558 20.3081C24.8431 20.6209 24.476 20.7772 24.0545 20.7772H19.2708C19.2708 21.969 18.8569 22.9787 18.0292 23.8064C17.2015 24.6342 16.1918 25.048 15 25.048ZM5.9455 19.2068H24.0545C24.0545 16.6266 23.1732 14.4338 21.4106 12.6283C19.648 10.8227 17.5115 9.91992 15.0011 9.91992C12.4907 9.91992 10.3539 10.8227 8.59053 12.6283C6.82718 14.4338 5.9455 16.6266 5.9455 19.2068ZM15.003 23.4776C15.7526 23.4776 16.3896 23.2147 16.9139 22.689C17.4382 22.1633 17.7003 21.526 17.7003 20.7772H12.2997C12.2997 21.5288 12.5628 22.1668 13.0891 22.6911C13.6154 23.2154 14.2534 23.4776 15.003 23.4776Z",
    fill: "#6B7280"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.8fef2984917a1917543caf9e18b7e7a7.svg";
export { ForwardRef as ReactComponent };